import { render, staticRenderFns } from "./ShopifyCustomer.vue?vue&type=template&id=27a8fae4"
import script from "./ShopifyCustomer.vue?vue&type=script&lang=js"
export * from "./ShopifyCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports